import { render, staticRenderFns } from "./EmulatorCustomizationInputWrapper.vue?vue&type=template&id=f50cf876"
import script from "./EmulatorCustomizationInputWrapper.vue?vue&type=script&lang=js"
export * from "./EmulatorCustomizationInputWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports